document.addEventListener('DOMContentLoaded', () => {
  const heroes = document.querySelectorAll('.main-rose-hero-stl');

  heroes.forEach((hero) => {
    const themeDialog = document.getElementById('quick-add-dialog');
    const themeDialogContent = document.getElementById('quick-add-modal-content');

    async function openThemeQuickAdd(productUrl) {
      if (!productUrl) return;

      if (!themeDialog || !themeDialogContent) {
        window.location.href = productUrl;
        return;
      }

      try {
        const response = await fetch(productUrl, {
          credentials: 'same-origin'
        });

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const productGrid = html.querySelector('[data-product-grid-content]');

        if (!productGrid) {
          window.location.href = productUrl;
          return;
        }

        themeDialogContent.innerHTML = '';
        themeDialogContent.appendChild(productGrid.cloneNode(true));

        if (window.customElements && typeof window.customElements.upgrade === 'function') {
          window.customElements.upgrade(themeDialogContent);
        }

        if (typeof themeDialog.showDialog === 'function') {
          themeDialog.showDialog();
          return;
        }

        const nativeDialog = themeDialog.querySelector('dialog');
        if (nativeDialog && typeof nativeDialog.showModal === 'function') {
          if (!nativeDialog.open) nativeDialog.showModal();
          return;
        }

        window.location.href = productUrl;
      } catch (error) {
        console.error('Main Rose hotspot quick add error:', error);
        window.location.href = productUrl;
      }
    }

    hero.querySelectorAll('.main-rose-hotspot').forEach((hotspot) => {
      const button = hotspot.querySelector('.main-rose-hotspot__button');
      const jsonScript = hotspot.querySelector('.main-rose-hotspot__product-json');
      if (!button || !jsonScript) return;

      let product = null;

      try {
        product = JSON.parse(jsonScript.textContent);
      } catch (error) {
        console.error('Could not parse hotspot product JSON', error);
      }

      if (!product?.url) return;

      const openHandler = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        await openThemeQuickAdd(product.url);
      };

      button.addEventListener('click', openHandler);
      button.addEventListener(
        'touchstart',
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          openThemeQuickAdd(product.url);
        },
        { passive: false }
      );
    });
  });
});